import type { PropsWithChildren, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { css } from "../../../../styled-system/css";
import { ProgressBar } from "react-aria-components";
import { ImSpinner2 } from "react-icons/im";

const Box = ({
  empty,
  emptyMessage,
  isPending,
  children,
}: PropsWithChildren & { empty: boolean; emptyMessage?: ReactNode; isPending: boolean }) => {
  const { t } = useTranslation(["common"]);
  return (
    <div
      data-empty={empty}
      className={css({
        border: "1px solid",
        borderColor: "gray.200",
        borderRadius: "15px",
        width: "100%",
        height: "full",
        minHeight: "150px",
        padding: "15px",
        "&[data-empty=true]": {
          color: "gray.500",
          background: "gray.100",
        },
      })}
    >
      {(isPending || empty) && (
        <div
          className={css({
            height: "120px",
            color: "gray.500",
            fontSize: "1.5rem",
            fontWeight: "bold",
            lineHeight: "120px",
            textAlign: "center",
            fontStyle: "italic",
          })}
        >
          {isPending ?
            <ProgressBar aria-label={t(($) => $.common["Loading..."])} isIndeterminate>
              <ImSpinner2
                className={css({
                  animation: "spin",
                })}
              />
            </ProgressBar>
          : emptyMessage || t(($) => $.common["No data available"])}
        </div>
      )}
      {children}
    </div>
  );
};

export default Box;
